import { createFileRoute } from '@tanstack/react-router'
import { Honoraires } from '@/views/honoraires/Honoraires'

export const Route = createFileRoute('/_authenticated/honoraires')({
    component: Honoraires,
})
